import { PresentationBundleKind } from '@/types/schema';

import {
  ClientPresentationBundleConfigurationBase,
  ClientPresentationV2Bundle,
} from '../../types/ClientPresentation.PresentationBundleType';
import { BundleSaveDescriptor } from '../presentationSave.types';
import { diffDocumentsReviewedBundleConfiguration } from './documentsReviewedBundle';
import { diffEntitiesOverviewBundleConfiguration } from './entitiesOverviewBundle';
import { diffFamilyOverviewBundleConfiguration } from './familyOverviewBundle';
import { canWriteOwnedConfig } from './flatConfigDescriptor';
import { diffPlanningOpportunitiesBundleConfiguration } from './planningOpportunitiesBundle';

type ListBundleKind =
  | PresentationBundleKind.DocumentsReviewedBundle
  | PresentationBundleKind.EntitiesOverviewBundle
  | PresentationBundleKind.FamilyOverviewBundle
  | PresentationBundleKind.PlanningOpportunitiesBundle;

function createListBundleDescriptor(
  kind: ListBundleKind,
  ownedField: keyof ClientPresentationV2Bundle,
  readConfiguration: (
    bundle: ClientPresentationV2Bundle
  ) => ClientPresentationBundleConfigurationBase | undefined
): BundleSaveDescriptor {
  return {
    ownedFields: [ownedField],
    canWrite: (previous, next) =>
      canWriteOwnedConfig(readConfiguration, previous, next),
    diffConfiguration: (args) => {
      switch (kind) {
        case PresentationBundleKind.DocumentsReviewedBundle:
          return diffDocumentsReviewedBundleConfiguration(args);
        case PresentationBundleKind.EntitiesOverviewBundle:
          return diffEntitiesOverviewBundleConfiguration(args);
        case PresentationBundleKind.FamilyOverviewBundle:
          return diffFamilyOverviewBundleConfiguration(args);
        case PresentationBundleKind.PlanningOpportunitiesBundle:
          return diffPlanningOpportunitiesBundleConfiguration(args);
      }
    },
  };
}

export const documentsReviewedBundleDescriptor = createListBundleDescriptor(
  PresentationBundleKind.DocumentsReviewedBundle,
  'documentsReviewedBundleConfiguration',
  (bundle) => bundle.documentsReviewedBundleConfiguration
);

const entitiesOverviewListDescriptor = createListBundleDescriptor(
  PresentationBundleKind.EntitiesOverviewBundle,
  'entitiesOverviewConfiguration',
  (bundle) => bundle.entitiesOverviewConfiguration
);

export const entitiesOverviewBundleDescriptor: BundleSaveDescriptor = {
  ...entitiesOverviewListDescriptor,
  canWrite: (previous, next) => {
    if (
      !previous.entitiesOverviewConfiguration &&
      next.entitiesOverviewConfiguration
    ) {
      return true;
    }
    return entitiesOverviewListDescriptor.canWrite(previous, next);
  },
};

export const familyOverviewBundleDescriptor = createListBundleDescriptor(
  PresentationBundleKind.FamilyOverviewBundle,
  'familyOverviewBundleConfiguration',
  (bundle) => bundle.familyOverviewBundleConfiguration
);

export const planningOpportunitiesBundleDescriptor = createListBundleDescriptor(
  PresentationBundleKind.PlanningOpportunitiesBundle,
  'planningOpportunitiesBundleConfiguration',
  (bundle) => bundle.planningOpportunitiesBundleConfiguration
);
